import React from "react";

// Shared editorial header for the marketing sub-pages (How it works, Rates,
// FAQ, About). Replaces the eyebrow/h1/lead trio that each of those pages had
// copy-pasted at a flat 34px, which read noticeably thinner than the Home
// hero's oversized treatment and made the sub-pages feel like a different site.
//
// Three deliberate typographic choices:
//   - The headline is FLUID (clamp) rather than a fixed px size, so it scales
//     with the viewport instead of stepping at breakpoints.
//   - Negative tracking at display sizes. Letter-spacing that reads correctly at
//     16px looks loose at 50px; the larger the type, the tighter it wants to be.
//   - The lead paragraph is capped at 64ch and set at 1.65 line-height. Measure
//     is what makes long-form marketing copy readable, not font size.
//
// The hairline rule + letterspaced eyebrow mirrors the Home hero so the whole
// marketing site reads as one voice.
const PageHeader = ({ eyebrow, title, children, className = "" }) => (
  <header className={className}>
    <div className="flex items-center gap-3">
      <span className="h-px w-9 bg-[var(--accent)]" aria-hidden="true" />
      <span className="font-disp uppercase tracking-[.2em] text-[12px] font-semibold text-[var(--accent)]">
        {eyebrow}
      </span>
    </div>

    <h1 className="font-disp font-bold text-[clamp(32px,4.4vw,52px)] leading-[1.04] tracking-[-.02em] mt-4 max-w-[22ch]">
      {title}
    </h1>

    {children && (
      <div className="text-[var(--muted)] mt-4 max-w-[64ch] text-[17px] leading-[1.65]">{children}</div>
    )}
  </header>
);

export default PageHeader;
